<template>
       <div class="container">
                <div class="page-header">
                    <div class="page-title">
                     
                        <div class="crumbs">
                            <ul id="breadcrumbs" class="breadcrumb">
                                <li>
                                  <router-link :title="'الرئيسيه'" :to="{name: 'dashboard'}"> <i class="flaticon-home-fill"></i> الرئيسيه</router-link>
                                </li>
                                <li class="active">
                                  <router-link :title="'السندات'" :to="{name: 'vouchers'}">السندات</router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                
                <div class="row"> 
                    <div class="col-lg-12 col-md-12 layout-spacing">
                        <div class="statbox widget box box-shadow">
                            <div class="widget-header">
     

                                <div class="row align-items-center">
                                    <div class="col-md-6">
                                        <h4>
                                            <i class="flaticon-computer-4"></i> 
                                        السندات
                                        </h4>
                                    </div> 
                                    <div class="col-md-6">
                                      <ul class="list-inline top-btns d-flex align-items-center m-0">
                                        <li class="list-inline-item"><create-button  v-if="hasPermissions('vouchers_create')" :routeName="'vouchers.create'"></create-button></li>
                                        <li class="list-inline-item">
                                          <button class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1
" v-if="searchingMode == 0" @click="searchingMode = 1"> <span>فلاتر البحث</span></button>
                                          <button class="btn btn-danger search-btn-wg mb-2 my-2 " v-if="searchingMode == 1" @click="searchingMode = 0">إغلاق X</button></li>
                                      </ul>
                                                                    
                                      </div>         
                                </div>
                            </div>
                            <div class="widget-content widget-content-area">
                                
                                <form @submit.prevent="getIndexData(1)" v-if="searchingMode == 1" style="border: 1px solid #DDD;padding: 20px" class="mb-4">
                                    <div class="form-row">
                                        <div class="col-md-12 mt-2">
                                          <label for="">المرحلة الدراسية</label>
                                          <v-select v-model="stage" :options="stages" @search="onSearchStage" />
                                        </div>
                                        <div class="col-md-3 mt-2">
                                          <label for="">من تاريخ </label>
                                          <date-picker v-model="data.searching.date_from"  :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-3 mt-2">
                                          <label for="">إلى تاريخ </label>
                                          <date-picker v-model="data.searching.date_to"  :calendar="'hijri'"></date-picker>
                                        </div>
                                        <div class="col-md-3 mt-2">
                                          <label for="">نوع السند</label><br>
                                          <input type="radio" v-model="data.searching.type" value="">الكل
                                          <input type="radio" v-model="data.searching.type" value="cash">قبض
                                            <input type="radio" v-model="data.searching.type" value="receipt">صرف
                                        </div>
                                         <div class="col-md-3 mt-2">
                                          <label for="">رسوم دراسية / برنامج</label><br>
                                          <input type="radio" v-model="data.searching.is_fees" value="">الكل
                                          <input type="radio" v-model="data.searching.is_fees" value="1">رسوم دراسية
                                            <input type="radio" v-model="data.searching.is_fees" value="0">برامج
                                        </div>
                                        <div class="col-md-4 mt-2">
                            <button type="submit" name="time" class="search-btn-wg btn-creative btn-3 btn-3e flaticon-search-1"> <span>بحث</span></button>

                                          <!-- <input type="submit" name="time" class=" btn btn-button-7 btn-block" value="بــــحــث"> -->
                                        </div>
                                    </div>
                                </form>
                                <div class="table-responsive">
                                  <div class="row mb-2">
                                      <div class="col-md-12">
                                        <p>رصيد الخزنة: {{cash}}</p>
                                        
                                      </div>
                                      <div class="col-md-1">
                                        <span>إظهار</span>
                                        <select v-model="data.searching.perPage" @change="getIndexData(1)" class="form-control">
                                            <option value="10">10</option>
                                            <option value="25">25</option>
                                            <option value="50">50</option>
                                            <option value="100">100</option>
                                        </select>
                                      </div>
                                    </div>
                                    
                                    <div class="col-md-12">
                                      <button @click.prevent="printTable" v-if="data.data.length" class="btn btn-success mt-2 mb-2">
                                        <i class="fa fa-print"></i> طباعة
                                      </button>
                                    </div>
                                    <div class="col-md-12" id="print-table">
                                          
                                        <table class="table table-bordered mb-4">
                                            <thead>
                                                <tr>
                                                    <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">التكلفة الفعلية</th>
                                                    <th @click="resortData();">نوع السند</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th @click="resortData();">رسوم دراسية / برنامج</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item, index) in data.data" :key="index">
                                                    <td>{{item.id}}</td>
                                                    <td>{{item.created_date}}</td>
                                                    <td>{{item.total_cost}}</td>
                                                    <td>{{item.type == 'cash' ? 'سند قبض' : 'سند صرف'}}</td>
                                                    <td>
                                                      <label v-for="(st, k) in item.stages" :key="k" class="badge badge-success">{{st.name}}</label>

                                                    </td>
                                                    <td>
                                                      <label v-if="item.is_fees == 1" class="badge badge-info">رسوم دراسية</label>
                                                      <label v-else class="badge badge-primary">برنامج</label>
                                                    </td>
                                                    <td class="text-center">
                                                        
                                                        <div class="dropdown custom-dropdown">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                                                <i class="flaticon-dot-three fs-17"></i>
                                                            </a>

                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a href="#" class="dropdown-item" @click.prevent="print(item)">طباعة</a>
                                                                <edit-button v-if="hasPermissions('vouchers_edit')" :routing="{name: 'vouchers.edit', params: {id: item.id}}"></edit-button>

                                                                <delete-button v-if="hasPermissions('vouchers_delete')" :deleteUrl="'/vouchers/' + item.id" :data="item" @deleteData="deleteData"></delete-button>
                                                            </div>
                                                        </div>

                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                  <th>
                                                      <a href="#" @click.prevent="resortData();">
                                                        <i class="flaticon-arrow-down-1" v-if="data.searching.sorting == 'asc'"></i>
                                                        <i class="flaticon-arrow-up" v-if="data.searching.sorting == 'desc'"></i>
                                                      </a>
                                                    </th>
                                                    <th @click="resortData();">التاريخ</th>
                                                    <th @click="resortData();">التكلفة الفعلية</th>
                                                    <th @click="resortData();">نوع السند</th>
                                                    <th @click="resortData();">المرحلة الدراسية</th>
                                                    <th @click="resortData();">رسوم دراسية / برنامج</th>
                                                    <th class="align-center">#</th>
                                                </tr>
                                            </tfoot>
                                            
                                        </table>
                                    </div>

                                </div>
                                <div class="row">
                                  <div class="col-md-4">
                                    <simple-pagination :data="data.paginated" @getIndexData="getIndexData($event)"></simple-pagination>
                                  </div>
                                  <div class="col-md-8 mt-4">
                                    <table-info v-if="Object.keys(data.paginated).length" :data="data.paginated"></table-info>
                                  </div>
                                </div>
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
              <div class="row" style="display: none;" id="printMe">
                <div class="col-md-12">
                   <table class="table table-bordered">
                    <tbody>
                      <tr class="text-center">
                        <th colspan="4">
                          السند<br>
                        </th>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr>
                        <td colspan="2">التاريخ</td>
                        <td colspan="2">{{printData.created_date}}</td>
                      </tr>
                      <tr>
                        <td v-if="printData.is_fees == 0">كود البرنامج </td>
                        <td v-if="printData.is_fees == 0">{{printData.activity_id}}</td>
                        <td v-if="printData.is_fees == 1">البند </td>
                        <td v-if="printData.is_fees == 1">{{printData.item ? printData.item.name : '---'}}</td>
                        <td>المرحلة الدراسية</td>
                        <td>{{printData.stage ? printData.stage.name : '---'}}</td>
                      </tr>

                      <tr>
                        <td>إجمالى التكلفة </td>
                        <td>{{printData.total_cost}}</td>
                        <td>نوع السند </td>
                        <td>{{printData.type == 'cash' ? 'سند قبض' : 'سند صرف'}}</td>
                      </tr>

                      <tr v-if="printData.is_fees == 0">
                        <td>المدة  </td>
                        <td>{{printData.period}}</td>
                        <td> المكان </td>
                        <td>{{printData.place}}</td>
                      </tr>
                    
                      <tr v-if="printData.is_fees == 0">
                        <td>الوصف  </td>
                        <td>{{printData.description}}</td>
                        <td> المسئول </td>
                        <td>{{printData.teacher ? printData.teacher.name : '---'}}</td>
                      </tr>
                      <tr v-if="printData.is_fees == 1">
                        <td colspan="2">الطالب</td>
                        <td colspan="2">{{printData.student ? printData.student.name : '---'}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
             

            </div>


</template>
<script>
import 'vue-select/dist/vue-select.css';
import VueDatetimeJs from 'vue-datetime-js'

export default {
  components: {
    datePicker: VueDatetimeJs,
  },
  data() {
    return {
      cash: 0,
      printData: {
      },
      data: {
        data: {},
        searching:{
            id: '',
            type: '',
            stage_id: '',
            date_from: '',
            date_to: '',
            is_fees: '',
            perPage: 10,
            sorting: 'desc'
        },
        paginated: {},
        showFilter: false,
      },
       options: [],
       stages: [],
       groups: [],
       searchingMode: 0,
       stage: {},
       group: {},
    };
  },
  created(){
    this.flashAlert();

      this.search(null, '', this, 'stage');
      this.getCash();
      this.getIndexData(1);
  },
  methods: {
    
    resortData(){
        this.data.searching.sorting = this.data.searching.sorting == 'asc' ? 'desc' : 'asc';
        this.getIndexData(1);
    },
    printTable(){
      setTimeout(() => {
        this.print_element('print-table', 'السندات');
      }, 1000);
    },
    print(data){
      this.printData = data;
        this.$baseApi.get('/vouchers/' + data.id).then((response)=>{
            if(response.data.code == 200){
              this.printData = response.data.data.voucher;
              setTimeout(() => {
                this.print_element('printMe', 'سند');
              
              }, 2000);

            }else{
                alert(response.data.error.error);
            }
        });
    },
    onSearchStage(search, loading) {
      if(search.length) {
        loading(true);
        this.search(loading, search, this, 'stage');
      }
    },
    search(loading, w, vm, type){
      this.$baseApi.get('/vouchers?pluck=1&search='+w+'&pluckType='+type).then((response)=>{
            if(loading){
              loading(false);
            }
            if(response.data.code == 200){
              if(type == 'stage'){
                this.stages = response.data.data.options;
              }
            }else{
                alert(response.data.error.error);
            }
        });
    },
      getIndexData(page){
        this.$baseApi.get('/vouchers?page=' + page, {
                    params: this.data.searching
                }).then((response)=>{
            if(response.data.code == 200){
               this.data.paginated = response.data.data.vouchers;
               this.data.data = response.data.data.vouchers.data;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      getCash(){
        this.$baseApi.get('/vouchers?pluckType=cash').then((response)=>{
            if(response.data.code == 200){
               this.cash = response.data.data.cash;

            }else{
                alert(response.data.error.error);
            }
        });
      },
      deleteData(data){
          this.data.data.splice(this.data.data.indexOf(data), 1);
      },
    clearFilter(items) {
      this.data.showFilter = !this.data.showFilter
      if (!this.data.showFilter) {
        for (const itemsKey in items) {
          this.data.searching[itemsKey] = ''
        }
        this.getIndexData(1);
      }
    }
  },
  computed: {
    trans(){
      return this.$store.getters.GET_TRANS;
    },
    user(){
      return this.$store.getters.SET_AUTH_USER;
    }
  },
   watch: {
    // Note: only simple paths. Expressions are not supported.
    stage(newValue) {
      this.data.searching.stage_id = newValue.id;
    }
  }
};
</script>
<style>
</style>
